(function () {
  if (!window.__libasAsapConfig || !window.__libasAsapConfig.enabled) return;
  if (window.__libasCollectionHldStampsLoaded) return;
  window.__libasCollectionHldStampsLoaded = true;

  var ICON_URL = "https://cdn.shopify.com/s/files/1/0341/4805/7228/files/libas-asap-logo-20261006.png?v=1791287379&width=400";
  var EDD_ICON_URL = "https://cdn.shopify.com/s/files/1/0341/4805/7228/files/ex.png?v=1782723664";
  var STORAGE_KEY = "libasDeliveryLocation";
  var SERVICEABLE_COOKIE = "libas_serviceable_store_ids";
  var PINCODE_COOKIE_NAME = "di_clickpost_pincode";
  var PINCODE_STORAGE_KEY = "di_clickpost_pincode";
  var LOCATION_FILTER_PARAM = "filter.p.m.custom.available_locations";
  var LEGACY_LOCATION_FILTER_PARAM = "filter.v.m.custom.available_locations";
  var INVENTORY_NORMAL_HIDDEN_CLASS = "libas-inventory-normal-hidden";
  var ROOT_SELECTOR = "[data-ls-infinite-scroll-root][data-section-id]";
  var CARD_SELECTOR = ".grid-product[data-product-handle]";
  var CART_ITEM_SELECTOR = ".cart__item[data-product-handle]";
  var CART_PRODUCTS_SELECTOR = "#CartDrawer [data-products],#CartPageForm [data-products],form[data-location='header'] [data-products]";
  var STAMP_SELECTOR = "[data-libas-hld-stamp]";
  var CART_WARNING_SELECTOR = "[data-libas-inventory-warning]";
  var PRODUCT_CARD_HLD_SECTION = "libas-product-card-hld-data";
  var EXPRESS_PROMISE_TEXT = "Express Delivery";
  var CART_DELIVERY_ENDPOINT = "/apps/libas-delivery-timelines/api/cart-delivery-timelines";
  var CART_DELIVERY_TIMEOUT_MS = 15000;
  var CART_DELIVERY_CACHE_MS = 30000;
  var CART_DELIVERY_PROPERTY_KEYS = [
    "turnaround_time",
    "type_of_order",
    "location_id",
    "lat",
    "long",
    "hl_pin",
    "_hl_pin",
    "l0ng",
    "_location_id",
    "_lat",
    "_long",
    "_type_of_order",
    "_delivery_promise",
    "_turnaround_time"
  ];
  var fetchCache = {};
  var productCardDataCache = {};
  var cartDeliveryCache = new Map();
  // Display-only state survives markup replacement; never used for order properties.
  var cartDeliveryDisplay = new Map();
  var CART_LOADING_SELECTOR = "[data-libas-cart-delivery-loading]";
  var cartDeliveryRevision = 0;
  var cartDeliveryRecoveryPending = false;
  var runTimer = null;
  var cartLinePropertyWrite = Promise.resolve();
  var cartPropertyRefreshTimer = null;
  var cartPropertyRefreshInFlight = null;
  var cartPropertyRefreshQueued = false;
  var stylesInjected = false;
  var cartObserver = null;
  var collectionObservers = [];

  function normalizeIdList(value) {
    var raw = Array.isArray(value) ? value : (value == null || value === "" ? [] : [value]);
    var ids = [];
    var seen = {};

    raw.forEach(function (entry) {
      String(entry == null ? "" : entry).split(/[,\s|]+/).forEach(function (part) {
        var id = "";
        var gidMatch;

        part = part.trim();
        if (!part) return;

        gidMatch = part.match(/Location\/(\d+)$/);
        if (gidMatch) {
          id = gidMatch[1];
        } else if (/^\d+$/.test(part)) {
          id = part;
        }

        if (id && !seen[id]) {
          seen[id] = true;
          ids.push(id);
        }
      });
    });

    return ids;
  }

  function normalizeInventoryTypeList(value) {
    var raw = Array.isArray(value) ? value : (value == null || value === "" ? [] : [value]);
    var seen = {};
    var types = [];

    raw.forEach(function (entry) {
      String(entry == null ? "" : entry).split(/[,\s|]+/).forEach(function (part) {
        var type = part.trim().toLowerCase();
        if (!type) return;
        if (type !== "warehouse_only" && type !== "store_only" && type !== "both" && type !== "none") return;
        if (!seen[type]) {
          seen[type] = true;
          types.push(type);
        }
      });
    });

    return types;
  }

  function readCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie ? document.cookie.split(";") : [];

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.slice(prefix.length));
        } catch (error) {
          return part.slice(prefix.length);
        }
      }
    }

    return "";
  }

  function sanitizePincode(value) {
    return String(value || "").replace(/\D/g, "").slice(0, 6);
  }

  function normalizeText(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  function getStoredValue(storage, key) {
    if (!storage) return "";

    try {
      return storage.getItem(key) || "";
    } catch (error) {
      return "";
    }
  }

  function getDeliveryLocation() {
    var stateLocation = window.__libasDeliveryLocationState && window.__libasDeliveryLocationState.current;
    var stored;

    if (stateLocation && sanitizePincode(stateLocation.pincode).length === 6) {
      return stateLocation;
    }

    stored = getStoredValue(window.localStorage, STORAGE_KEY);
    if (!stored) return null;

    try {
      return JSON.parse(stored);
    } catch (error) {
      return null;
    }
  }

  function getSavedPincode() {
    var location = getDeliveryLocation();

    return sanitizePincode(
      location && location.pincode ||
      getStoredValue(window.localStorage, PINCODE_STORAGE_KEY) ||
      getStoredValue(window.sessionStorage, PINCODE_STORAGE_KEY) ||
      readCookie(PINCODE_COOKIE_NAME)
    );
  }

  function isValidCoordinate(value, min, max) {
    if (value == null || String(value).trim() === "") return false;
    var number = Number(value);
    return Number.isFinite(number) && number >= min && number <= max;
  }

  function getDeliveryLocationCoordinates(pincode) {
    var location = getDeliveryLocation();
    var locationPincode = sanitizePincode(location && location.pincode);
    var lat = location && (location.lat != null ? location.lat : location.latitude);
    var lng = location && (location.lng != null ? location.lng : location.long != null ? location.long : location.longitude);

    if (pincode && locationPincode !== sanitizePincode(pincode)) {
      return null;
    }

    if (!isValidCoordinate(lat, -90, 90) || !isValidCoordinate(lng, -180, 180)) {
      return null;
    }

    var formatted = {lat: formatApiCoordinate(lat), lng: formatApiCoordinate(lng)};
    return isValidCoordinate(formatted.lat, -90, 90) && isValidCoordinate(formatted.lng, -180, 180) ? formatted : null;
  }

  function formatApiCoordinate(value) {
    var parts = String(value).trim().toLowerCase().split("e");
    var fraction = (parts[0].split(".")[1] || "").length;
    var precision = Math.max(0, fraction - Number(parts[1] || 0));
    var missing = Math.max(0, 7 - precision);
    var rounded = Number(value).toFixed(7);
    return missing ? rounded.slice(0, -missing) + "5".repeat(missing) : rounded;
  }

  function getServiceableStoreIds(pincode) {
    var location = getDeliveryLocation();
    var locationPincode = sanitizePincode(location && location.pincode);
    var ids;

    if (pincode && locationPincode !== sanitizePincode(pincode)) {
      return [];
    }

    return window.LibasDeliveryEligibility ? window.LibasDeliveryEligibility.getStoreIds(location) : [];
  }

  function getRequestLocationKey(pincode) {
    var coordinates = getDeliveryLocationCoordinates(pincode);
    var storeIds = getServiceableStoreIds(pincode);

    return [
      pincode || "",
      coordinates ? coordinates.lat : "",
      coordinates ? coordinates.lng : "",
      storeIds.join(",")
    ].join("|");
  }

  function readStoredLocationIds() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var location = stored ? JSON.parse(stored) : null;
      return window.LibasDeliveryEligibility ? window.LibasDeliveryEligibility.getStoreIds(location) : [];
    } catch (error) {
      return [];
    }
  }

  function readUrlLocationIds(url) {
    var values = []
      .concat(url.searchParams.getAll("loc"))
      .concat(url.searchParams.getAll("location_id"))
      .concat(url.searchParams.getAll("locations"))
      .concat(url.searchParams.getAll(LOCATION_FILTER_PARAM))
      .concat(url.searchParams.getAll(LEGACY_LOCATION_FILTER_PARAM));

    return normalizeIdList(values);
  }

  function getActiveLocationIds() {
    var url = new URL(window.location.href);
    var urlIds = readUrlLocationIds(url);
    var eligibleIds = getServiceableStoreIds();
    return urlIds.length ? eligibleIds.filter(function (id) { return urlIds.indexOf(id) !== -1; }) : eligibleIds;
  }

  function currentUrlHasLocationFilter() {
    return readUrlLocationIds(new URL(window.location.href)).length > 0;
  }

  function injectStyles() {
    if (stylesInjected) return;
    stylesInjected = true;

    var style = document.createElement("style");
    style.textContent = [
      ".libas-hld-stamp{display:inline-flex;align-items:center;justify-content:flex-start;gap:6px;margin-top:5px;color:#71006a;font-size:11px;font-weight:600;line-height:1;letter-spacing:0;text-align:left;text-transform:none;vertical-align:top}",
      ".libas-hld-stamp--edd{color:#555;font-weight:600}",
      ".libas-hld-stamp__icon{display:block;width:48px;height:auto;max-width:48px;flex:0 0 auto}",
      ".libas-hld-stamp__text{display:inline-flex;align-items:center;min-height:16px;color:#71006a;letter-spacing:0;line-height:1;white-space:normal}",
      ".libas-hld-stamp--edd .libas-hld-stamp__text{color:#555}",
      ".cart__item .libas-hld-stamp{margin-top:5px;gap:5px;font-size:11px;line-height:1.1;width:100%}",
      ".cart__item .libas-hld-stamp__icon{width:42px;max-width:42px}",
      ".libas-cart-delivery-loading{display:flex;align-items:center;min-height:18px;margin-top:5px;color:#71006a}",
      ".libas-cart-delivery-loading svg{display:block;width:36px;height:18px;overflow:hidden}",
	      ".cart__item .libas-hld-stamp__text{min-height:14px}",
	      "@media screen and (max-width:767px){.libas-hld-stamp{gap:5px;margin-top:4px;font-size:10.5px}.libas-hld-stamp__icon{width:40px;max-width:40px}.libas-hld-stamp__text{min-height:13px}}",
	      ".libas-hld-stamp--edd .libas-hld-stamp__icon{width:22px;max-width:22px}",
	      ".libas-inventory-warning{margin-top:6px;color:#b00020;font-size:11px;font-weight:600;line-height:1.25}",
	      ".libas-cart-has-inventory-block #CartDrawer .gokwik-checkout a,.libas-cart-has-inventory-block #CartDrawer [name='checkout']{pointer-events:none!important;opacity:.55!important}",
	      "." + INVENTORY_NORMAL_HIDDEN_CLASS + "{display:none!important}"
	    ].join("");
    document.head.appendChild(style);
  }

  function getRoots(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var roots = Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR));

    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.unshift(scope);
    }

    return roots.filter(function (root, index, list) {
      return list.indexOf(root) === index;
    });
  }

  function removeStamps(root, keepEdd) {
    Array.prototype.forEach.call((root || document).querySelectorAll(STAMP_SELECTOR), function (stamp) {
      if (keepEdd && stamp.classList.contains("libas-hld-stamp--edd")) return;
      if (stamp.parentNode) stamp.parentNode.removeChild(stamp);
    });
  }

  function buildStamp(promise) {
    var stamp;
    var icon;
    var text;
    var isHld = !promise || promise.isHld !== false;

    stamp = document.createElement("div");
    stamp.className = "libas-hld-stamp" + (isHld ? "" : " libas-hld-stamp--edd");
    stamp.setAttribute("data-libas-hld-stamp", "");

    icon = document.createElement("img");
    icon.className = "libas-hld-stamp__icon";
    icon.src = isHld ? ICON_URL : EDD_ICON_URL;
    icon.alt = "";
    icon.loading = "lazy";
    icon.decoding = "async";
    icon.width = 48;
    icon.height = 15;
    icon.setAttribute("aria-hidden", "true");

    text = document.createElement("span");
    text.className = "libas-hld-stamp__text";
    text.textContent = isHld ? "Get it in 2 hours" : normalizeText(promise.promiseText || promise.text || "");

    stamp.appendChild(icon);
    stamp.appendChild(text);

    return stamp;
  }

  function updateStamp(stamp, promise) {
    var isHld = !promise || promise.isHld !== false;
    var icon = stamp && stamp.querySelector(".libas-hld-stamp__icon");
    var text = stamp && stamp.querySelector(".libas-hld-stamp__text");
    var nextIconUrl = isHld ? ICON_URL : EDD_ICON_URL;
    var nextText = isHld ? "Get it in 2 hours" : normalizeText(promise.promiseText || promise.text || "");

    if (!stamp) return;
    stamp.classList.toggle("libas-hld-stamp--edd", !isHld);
    if (icon && icon.getAttribute("src") !== nextIconUrl) {
      icon.src = nextIconUrl;
    }
    if (text && text.textContent !== nextText) {
      text.textContent = nextText;
    }
  }

  function removeStamp(container) {
    var existing = container && container.querySelector(STAMP_SELECTOR);
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
  }

  function addStamp(card, promise) {
    var price = card.querySelector(".grid-product__meta .grid-product__price") || card.querySelector(".grid-product__price");
    var existing = card.querySelector(STAMP_SELECTOR);

    if (existing) {
      updateStamp(existing, promise);
      return;
    }

    if (!price) return;
    price.insertAdjacentElement("afterend", buildStamp(promise));
  }

  function addCartStamp(item, promise) {
    var target = item.querySelector(".item-info-container") ||
      item.querySelector(".cart__item-price-col") ||
      item.querySelector(".cart__item-title");
    var existing = item.querySelector(STAMP_SELECTOR);

    if (existing) {
      updateStamp(existing, promise);
      return;
    }

    if (!target) return;
    target.insertAdjacentElement("afterend", buildStamp(promise));
  }

  function cartDisplayShape(items) {
    return JSON.stringify(items.map(function (item) {
      return [String(item.variant_id), normalizeText(item.sku), Number(item.quantity)];
    }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }));
  }

  function cartTargetDisplayKey(target) {
    var container = target.closest("[data-products]") || target.closest("form");
    if (!container) return "";
    var items = Array.prototype.map.call(container.querySelectorAll(CART_ITEM_SELECTOR), function (item) {
      var input = item.querySelector(".js-qty__num");
      return { variant_id: item.dataset.libasDeliveryVariantId, sku: item.dataset.libasDeliverySku, quantity: input && input.value };
    });
    return getRequestLocationKey(getSavedPincode()) + "|" + cartDisplayShape(items);
  }

  function cartTargetInventoryKey(target) {
    return JSON.stringify([target.dataset.libasDeliveryAvailable, target.dataset.libasInventoryTypes, target.dataset.libasHldLocationIds]);
  }

  function removeCartLoader(target) {
    var loader = target.querySelector(CART_LOADING_SELECTOR);
    if (loader) loader.remove();
  }

  function showCartLoader(target) {
    if (target.querySelector(CART_LOADING_SELECTOR)) return;
    var anchor = target.querySelector(".item-info-container") || target.querySelector(".cart__item-price-col") || target.querySelector(".cart__item-title");
    if (!anchor) return;
    var loader = document.createElement("div");
    loader.className = "libas-cart-delivery-loading";
    loader.setAttribute("data-libas-cart-delivery-loading", "");
    loader.setAttribute("role", "status");
    loader.setAttribute("aria-label", "Checking delivery");
    loader.innerHTML = '<svg viewBox="0 0 120 60" aria-hidden="true"><g fill="currentColor">' + [46, 64, 34].map(function (width, index) {
      return '<rect x="-' + width + '" y="' + (18 + index * 10) + '" width="' + width + '" height="3" rx="1.5"><animate attributeName="x" values="-' + width + ';20;120" keyTimes="0;0.4;1" dur="0.9s" begin="' + index * 0.12 + 's" repeatCount="indefinite"/><animate attributeName="opacity" values="0;1;0" keyTimes="0;0.4;1" dur="0.9s" repeatCount="indefinite"/></rect>';
    }).join("") + '</g></svg>';
    anchor.insertAdjacentElement("afterend", loader);
  }

  function renderCartDeliveryResult(target, result) {
    removeCartLoader(target);
    removeCartInventoryWarning(target);
    if (result.status === "available" && result.promise) {
      addCartStamp(target, result.promise);
    } else {
      if (result.status === "error" && result.displayPromise) addCartStamp(target, result.displayPromise);
      else removeStamp(target);
      if (result.status === "unavailable") {
        addCartInventoryWarning(target, "This item is unavailable at this location. Change location or remove it to checkout.");
      } else if (isStoreOnlyInventoryTarget(target)) {
        addCartInventoryWarning(target);
      }
    }
  }

  function restoreCartDeliveryDisplay(context) {
    var targets = getDeliveryTargets(context || document).filter(function (target) { return target.matches(CART_ITEM_SELECTOR); });
    cartDeliveryDisplay.forEach(function (entry, key) {
      if (entry.expiresAt <= Date.now()) cartDeliveryDisplay.delete(key);
    });
    targets.forEach(function (target) {
      var entry = cartDeliveryDisplay.get(target.dataset.key);
      if (entry && entry.displayKey === cartTargetDisplayKey(target) && entry.inventoryKey === cartTargetInventoryKey(target)) {
        renderCartDeliveryResult(target, entry.result);
      } else {
        removeStamp(target);
        // Leave existing inventory blocks in place until a fresh response clears them.
        if (getSavedPincode().length === 6 && isDeliveryTargetAvailable(target)) showCartLoader(target);
        else removeCartLoader(target);
      }
    });
    syncCartCheckoutBlocking();
  }

  function removeCartInventoryWarning(item) {
    var warning = item && item.querySelector(CART_WARNING_SELECTOR);
    if (warning && warning.parentNode) warning.parentNode.removeChild(warning);
    if (item) item.removeAttribute("data-libas-inventory-blocked");
  }

  function addCartInventoryWarning(item, message) {
    var target = item.querySelector(".item-info-container") ||
      item.querySelector(".cart__item-price-col") ||
      item.querySelector(".cart__item-title");
    var warning = item.querySelector(CART_WARNING_SELECTOR);

    if (!target) return;
    item.setAttribute("data-libas-inventory-blocked", "true");

    if (!warning) {
      warning = document.createElement("div");
      warning.className = "libas-inventory-warning";
      warning.setAttribute("data-libas-inventory-warning", "");
      target.insertAdjacentElement("afterend", warning);
    }

    warning.textContent = message || "This item is available only with Libas ASAP. Change location or remove it to checkout.";
  }

  function syncCartCheckoutBlocking() {
    // Delivery refresh/reconciliation is not an inventory failure.
    var hasBlockedLine = Boolean(document.querySelector(CART_ITEM_SELECTOR + "[data-libas-inventory-blocked='true']"));
    document.documentElement.classList.toggle("libas-cart-has-inventory-block", hasBlockedLine);
    document.body.classList.toggle("libas-cart-has-inventory-block", hasBlockedLine);
  }

  function getLoadedPageCount(root) {
    var controller = root && root.__libasInfiniteController;
    if (controller && typeof controller.getLoadedPageCount === "function") {
      return Math.max(1, parseInt(controller.getLoadedPageCount(), 10) || 1);
    }

    return 1;
  }

  function getCurrentPageNumber() {
    var page = parseInt(new URL(window.location.href).searchParams.get("page"), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function buildFilteredSectionUrl(root, ids, pageNumber) {
    var url = new URL(window.location.href);

    url.searchParams.delete("loc");
    url.searchParams.delete("location_id");
    url.searchParams.delete("locations");
    url.searchParams.delete(LOCATION_FILTER_PARAM);
    url.searchParams.delete(LEGACY_LOCATION_FILTER_PARAM);
    url.searchParams.delete("section_id");

    ids.forEach(function (id) {
      url.searchParams.append(LOCATION_FILTER_PARAM, id);
    });

    if (pageNumber > 1) {
      url.searchParams.set("page", String(pageNumber));
    } else {
      url.searchParams.delete("page");
    }

    url.searchParams.set("section_id", root.dataset.sectionId);
    return url.toString();
  }

  function parseHandlesFromHtml(html) {
    var wrapper = document.createElement("div");
    var handles = {};

    wrapper.innerHTML = html;
    Array.prototype.forEach.call(wrapper.querySelectorAll(CARD_SELECTOR), function (card) {
      if (card.dataset.productHandle) {
        handles[card.dataset.productHandle] = true;
      }
    });

    return handles;
  }

  function fetchHandlesForPage(root, ids, pageNumber) {
    var url = buildFilteredSectionUrl(root, ids, pageNumber);

    if (!fetchCache[url]) {
      fetchCache[url] = window.fetch(url, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Two-hour stamp lookup failed.");
          return response.text();
        })
        .then(parseHandlesFromHtml)
        .catch(function () {
          return {};
        });
    }

    return fetchCache[url];
  }

  function fetchMatchingHandles(root, ids) {
    var basePage = getCurrentPageNumber();
    var loadedPageCount = getLoadedPageCount(root);
    var requests = [];

    for (var index = 0; index < loadedPageCount; index += 1) {
      requests.push(fetchHandlesForPage(root, ids, basePage + index));
    }

    return Promise.all(requests).then(function (pages) {
      var handles = {};

      pages.forEach(function (pageHandles) {
        Object.keys(pageHandles || {}).forEach(function (handle) {
          handles[handle] = true;
        });
      });

      return handles;
    });
  }

  function applyHandleStamps(root, handles, stampAll) {
    Array.prototype.forEach.call(root.querySelectorAll(CARD_SELECTOR), function (card) {
      var shouldStamp = stampAll || Boolean(handles && handles[card.dataset.productHandle]);
      var existing = card.querySelector(STAMP_SELECTOR);

      if (shouldStamp) {
        addStamp(card, { isHld: true, promiseText: "Get it in 2 hours" });
      } else if (existing && !existing.classList.contains("libas-hld-stamp--edd") && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    });
  }

  function hasMatchingLocationId(availableIds, activeIds) {
    return getMatchingLocationIds(availableIds, activeIds).length > 0;
  }

  function getMatchingLocationIds(availableIds, activeIds) {
    var activeMap = {};
    var matches = [];

    activeIds.forEach(function (id) {
      activeMap[id] = true;
    });

    availableIds.forEach(function (id) {
      if (activeMap[id] && matches.indexOf(id) === -1) {
        matches.push(id);
      }
    });

    return matches;
  }

  function isProductCard(target) {
    return Boolean(target && target.matches && target.matches(CARD_SELECTOR));
  }

  function getTargetAvailableLocationIds(target) {
    return normalizeIdList(target && target.dataset && target.dataset.libasHldLocationIds || "");
  }

  function getTargetInventoryTypes(target) {
    return normalizeInventoryTypeList(target && target.dataset && target.dataset.libasInventoryTypes || target && target.dataset && target.dataset.libasInventoryType || "");
  }

  function hasWarehouseBackedInventory(target) {
    var types = getTargetInventoryTypes(target);
    if (!types.length) return true;
    return types.indexOf("warehouse_only") !== -1 || types.indexOf("both") !== -1;
  }

  function isStoreOnlyInventoryTarget(target) {
    var types = getTargetInventoryTypes(target);
    if (!types.length) return false;
    return types.indexOf("store_only") !== -1 && types.indexOf("warehouse_only") === -1 && types.indexOf("both") === -1;
  }

  function syncNormalInventoryVisibility(target, activeLocationIds) {
    var shouldHide = isProductCard(target) && !normalizeIdList(activeLocationIds).length && !hasWarehouseBackedInventory(target);

    target.classList.toggle(INVENTORY_NORMAL_HIDDEN_CLASS, shouldHide);
    if (shouldHide) removeStamp(target);
    return !shouldHide;
  }

  function isDeliveryTargetAvailable(target) {
    if (!target || target.hasAttribute("data-sold-out-product")) return false;
    return String(target.dataset.libasDeliveryAvailable || "true").toLowerCase() !== "false";
  }

  function shouldShowProductLevelHld(target, activeLocationIds) {
    var availableIds;

    if (!isProductCard(target)) return false;
    if (!isDeliveryTargetAvailable(target)) return false;

    availableIds = getTargetAvailableLocationIds(target);
    return Boolean(availableIds.length && activeLocationIds.length && hasMatchingLocationId(availableIds, activeLocationIds));
  }

  function getDeliveryTargets(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var selectors = CARD_SELECTOR + "[data-libas-delivery-sku]," + CART_ITEM_SELECTOR + "[data-libas-delivery-sku]";
    var targets = Array.prototype.slice.call(scope.querySelectorAll(selectors));

    if (scope.matches && scope.matches(CARD_SELECTOR + "[data-libas-delivery-sku]," + CART_ITEM_SELECTOR + "[data-libas-delivery-sku]")) {
      targets.unshift(scope);
    }

    return targets.filter(function (target, index, list) {
      return list.indexOf(target) === index;
    });
  }

  function cartFingerprint(cart) {
    return JSON.stringify([String(cart && cart.token || ""), (cart && cart.items || []).map(function (item) {
      return JSON.stringify([String(item.key), String(item.variant_id), String(item.sku == null ? "" : item.sku), item.quantity,
        Object.keys(item.properties || {}).sort().map(function (key) { return [key, item.properties[key]]; })]);
    }).sort()]);
  }

  function cartPropertyWriteMatches(previousCart, updatedCart, lineId, properties) {
    if (!previousCart || !updatedCart || previousCart.token !== updatedCart.token ||
        !Array.isArray(updatedCart.items) || previousCart.items.length !== updatedCart.items.length) return false;
    var unchangedKeys = new Set(previousCart.items.filter(function (item) {
      return item.key !== lineId;
    }).map(function (item) { return item.key; }));
    var updatedKeys = new Set(updatedCart.items.map(function (item) { return item && item.key; }));
    if (unchangedKeys.size !== previousCart.items.length - 1 || updatedKeys.size !== updatedCart.items.length ||
        updatedCart.items.some(function (item) { return !item || typeof item.key !== "string" || !item.key; })) return false;
    var changedItems = updatedCart.items.filter(function (item) { return !unchangedKeys.has(item.key); });
    if (changedItems.length !== 1) return false;
    var expectedCart = {
      token: previousCart.token,
      items: previousCart.items.map(function (item) {
        return item.key === lineId ? Object.assign({}, item, { key: changedItems[0].key, properties: properties }) : item;
      })
    };
    return cartFingerprint(expectedCart) === cartFingerprint(updatedCart);
  }

  function cartRequestIsCurrent(request) {
    return Boolean(window.__libasAsapConfig.enabled && request &&
      request.revision === cartDeliveryRevision && request.expiresAt > Date.now() &&
      request.locationKey === getRequestLocationKey(getSavedPincode()));
  }

  function normalizeCartDeliveryLine(line, task) {
    var failure = deliveryFailureResult(task.target);
    if (!line || line.lineId !== task.lineId || normalizeText(line.sku) !== task.sku ||
        String(line.variantId) !== task.variantId) return failure;
    if (line.status === "unavailable") {
      return { status: "unavailable", promise: null, target: task.target };
    }
    if (line.status === "error") {
      var fallback = typeof line.displayFallback === "string" ? line.displayFallback :
        line.displayFallback && line.displayFallback.promiseText;
      fallback = normalizeText(fallback);
      if (fallback === "express") fallback = EXPRESS_PROMISE_TEXT;
      if (fallback === "unavailable") fallback = "Delivery currently unavailable";
      if (fallback) failure.displayPromise = { isHld: false, promiseText: fallback };
      return failure;
    }
    var properties = line.properties || {};
    var locationId = normalizeIdList(line.assignedLocationId)[0];
    var isHld = line.isHld === true;
    if (line.status !== "available" || typeof line.isHld !== "boolean" || !locationId ||
        normalizeIdList(properties._location_id)[0] !== locationId ||
        properties._type_of_order !== (isHld ? "qc" : "normal") ||
        String(properties._hl_pin) !== task.pincode || !normalizeText(line.promiseText)) return failure;
    if (isHld && (!isValidCoordinate(properties._lat, -90, 90) ||
        !isValidCoordinate(properties._long, -180, 180))) return failure;
    return {
      status: "available",
      target: task.target,
      properties: properties,
      promise: {
        assignedLocationId: locationId,
        isHld: isHld,
        priority: line.priority,
        promiseText: isHld ? "Get it in 2 hours" : normalizeText(line.promiseText)
      }
    };
  }

  function fetchCartDeliveryBatch(tasks, pincode, request) {
    var coordinates = getDeliveryLocationCoordinates(pincode);
    var endpoint = CART_DELIVERY_ENDPOINT;
    var body = {
      drop_pincode: pincode,
      lines: tasks.map(function (task) {
        return { lineId: task.lineId, sku: task.sku, variantId: task.variantId, quantity: task.quantity };
      })
    };
    if (coordinates) {
      body.drop_latitude = coordinates.lat;
      body.drop_longitude = coordinates.lng;
    }
    if (!cartRequestIsCurrent(request)) return Promise.resolve(null);
    var key = JSON.stringify([request.fingerprint, request.locationKey, body]);
    cartDeliveryCache.forEach(function (entry, entryKey) {
      if (entry.expiresAt <= Date.now()) cartDeliveryCache.delete(entryKey);
    });
    var cached = cartDeliveryCache.get(key);
    if (cached) return cached.promise;
    var controller = new AbortController();
    var entry = { expiresAt: request.expiresAt };
    var timeout;
    var deadline = new Promise(function (_, reject) {
      timeout = window.setTimeout(function () {
        controller.abort();
        reject(new Error("Cart delivery lookup timed out."));
      }, CART_DELIVERY_TIMEOUT_MS);
    });
    entry.promise = Promise.race([deadline, window.fetch(endpoint, {
      body: JSON.stringify(body),
      credentials: "same-origin",
      cache: "no-store",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      method: "POST",
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart delivery lookup failed.");
      return response.json();
    })]).then(function (payload) {
      if (!payload || payload.source !== "serviceability2" || !Array.isArray(payload.lines) ||
          String(payload.drop && payload.drop.pincode) !== pincode ||
          coordinates && (!isValidCoordinate(payload.drop.lat, -90, 90) || !isValidCoordinate(payload.drop.lng, -180, 180) ||
            !(Math.abs(Number(payload.drop.lat) - Number(coordinates.lat)) <= 0.000001) ||
            !(Math.abs(Number(payload.drop.lng) - Number(coordinates.lng)) <= 0.000001))) throw new Error("Invalid cart delivery response.");
      var byId = new Map();
      payload.lines.forEach(function (line) {
        if (!line || typeof line.lineId !== "string" || byId.has(line.lineId)) {
          throw new Error("Ambiguous cart delivery response.");
        }
        byId.set(line.lineId, line);
      });
      if (payload.lines.length !== tasks.length) throw new Error("Incomplete cart delivery response.");
      var lines = tasks.map(function (task) {
        var line = byId.get(task.lineId);
        if (!line || normalizeText(line.sku) !== task.sku || String(line.variantId) !== task.variantId) {
          throw new Error("Mismatched cart delivery response.");
        }
        return line;
      });
      if (lines.some(function (line, index) {
        return normalizeCartDeliveryLine(line, tasks[index]).status === "error";
      })) cartDeliveryCache.delete(key);
      return { lines: lines, expiresAt: entry.expiresAt };
    }).catch(function () {
      if (cartDeliveryCache.get(key) === entry) cartDeliveryCache.delete(key);
      return null;
    }).finally(function () { window.clearTimeout(timeout); });
    cartDeliveryCache.set(key, entry);
    return entry.promise;
  }

  function fetchCartDeliveryPromises(targets, pincode) {
    if (!window.__libasAsapConfig.enabled || !targets.length || pincode.length !== 6) return Promise.resolve([]);
    var request = {
      locationKey: getRequestLocationKey(pincode), revision: cartDeliveryRevision,
      expiresAt: Date.now() + CART_DELIVERY_CACHE_MS
    };
    return fetchCartJson().then(function (cart) {
      if (!cartRequestIsCurrent(request)) return [];
      request.fingerprint = cartFingerprint(cart);
      request.displayKey = request.locationKey + "|" + cartDisplayShape(cart.items);
      var tasks = [];
      var targetsById = new Map();
      targets.forEach(function (target) {
        var index = findCartLineIndex(cart, target);
        var item = index >= 0 ? cart.items[index] : null;
        if (!item || !item.key || !Number.isInteger(item.quantity) || item.quantity < 1) return;
        var lineId = String(item.key);
        if (!targetsById.has(lineId)) {
          targetsById.set(lineId, []);
          tasks.push({ lineId: lineId, sku: normalizeText(item.sku), variantId: String(item.variant_id),
            quantity: item.quantity, pincode: pincode, target: target });
        }
        targetsById.get(lineId).push(target);
      });
      var groups = new Map();
      tasks.forEach(function (task) {
        var key = task.sku ? "sku:" + task.sku : "line:" + task.lineId;
        if (!groups.has(key)) groups.set(key, Object.assign({}, task, { quantity: 0, tasks: [] }));
        var group = groups.get(key);
        group.quantity += task.quantity;
        group.tasks.push(task);
      });
      var representatives = Array.from(groups.values());
      representatives.forEach(function (group) {
        if (group.sku) group.quantity = cart.items.reduce(function (quantity, item) {
          return quantity + (normalizeText(item.sku) === group.sku ? item.quantity : 0);
        }, 0);
      });
      var batches = [];
      for (var index = 0; index < representatives.length; index += 25) batches.push(representatives.slice(index, index + 25));
      return Promise.all(batches.map(function (batch) {
        return fetchCartDeliveryBatch(batch, pincode, request).then(function (payload) {
          if (payload) request.expiresAt = Math.min(request.expiresAt, payload.expiresAt);
          var results = [];
          batch.forEach(function (group, index) {
            group.tasks.forEach(function (task) {
              var line = payload && Object.assign({}, payload.lines[index], { lineId: task.lineId, variantId: task.variantId });
              results.push(Object.assign(normalizeCartDeliveryLine(line, task), {
                lineId: task.lineId, quantity: task.quantity, request: request, targets: targetsById.get(task.lineId)
              }));
            });
          });
          return results;
        });
      })).then(function (results) {
        if (!cartRequestIsCurrent(request)) return [];
        return fetchCartJson().then(function (currentCart) {
          if (!cartRequestIsCurrent(request) || cartFingerprint(currentCart) !== request.fingerprint) return [];
          return [].concat.apply([], results);
        });
      });
    }).catch(function () { return []; });
  }

  function deliveryFailureResult(target) {
    var types = getTargetInventoryTypes(target);
    var warehouseBacked = types.indexOf("warehouse_only") !== -1 || types.indexOf("both") !== -1;
    return {
      // Never pass the display label to the successful line-property writer.
      promise: null,
      displayPromise: isDeliveryTargetAvailable(target) ? {
        isHld: false,
        promiseText: warehouseBacked ? EXPRESS_PROMISE_TEXT : "Delivery currently unavailable"
      } : null,
      status: "error",
      target: target
    };
  }

  function getCartEndpoint(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    return root.replace(/\/?$/, "/") + String(path || "").replace(/^\//, "");
  }

  function fetchCartJson() {
    return window.fetch(getCartEndpoint("cart.js"), {
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        "Accept": "application/json"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart lookup failed.");
      return response.json();
    });
  }

  function isCartDeliveryProperty(key) {
    return CART_DELIVERY_PROPERTY_KEYS.indexOf(String(key || "")) !== -1;
  }

  function buildCartLineDeliveryProperties(result, pincode) {
    var normalizedPincode = sanitizePincode(pincode);
    var promise = result && result.promise;
    var properties = {};

    if (normalizedPincode.length !== 6) return properties;
    properties._hl_pin = normalizedPincode;

    if (!result || result.status !== "available" || !promise) return properties;
    properties._location_id = promise.assignedLocationId;
    properties._type_of_order = promise.isHld ? "qc" : "normal";
    properties._delivery_promise = promise.promiseText;
    var source = result.properties || {};
    if (isValidCoordinate(source._lat, -90, 90) && isValidCoordinate(source._long, -180, 180)) {
      properties._lat = String(source._lat);
      properties._long = String(source._long);
    }
    if (promise.isHld) properties._turnaround_time = "2";

    return properties;
  }

  function mergeCartLineProperties(currentProperties, deliveryProperties) {
    var merged = {};

    Object.keys(currentProperties || {}).forEach(function (key) {
      if (!isCartDeliveryProperty(key)) {
        merged[key] = currentProperties[key];
      }
    });

    Object.keys(deliveryProperties || {}).forEach(function (key) {
      var value = deliveryProperties[key];
      if (value == null || String(value).trim() === "") return;
      merged[key] = String(value).trim();
    });

    return merged;
  }

  function cartLinePropertiesMatch(left, right) {
    function normalized(properties) {
      return Object.keys(properties || {}).sort().map(function (key) {
        return key + "\u0000" + String(properties[key] == null ? "" : properties[key]);
      });
    }

    return JSON.stringify(normalized(left)) === JSON.stringify(normalized(right));
  }

  function findCartLineIndex(cart, target) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var targetKey = normalizeText(target && target.dataset && target.dataset.key);
    var variantId = normalizeText(target && target.dataset && target.dataset.libasDeliveryVariantId);
    var sku = normalizeText(target && target.dataset && target.dataset.libasDeliverySku);
    var keyIndex = items.findIndex(function (item) {
      return targetKey && String(item && item.key || "") === targetKey;
    });
    var candidates;

    if (targetKey) return keyIndex;

    candidates = items.map(function (item, index) {
      return { index: index, item: item };
    }).filter(function (candidate) {
      var sameVariant = variantId && String(candidate.item.variant_id || "") === variantId;
      var sameSku = sku && normalizeText(candidate.item.sku) === sku;
      return sameVariant && sameSku;
    });

    return candidates.length === 1 ? candidates[0].index : -1;
  }

  function syncCartTargetKeys(cart, previousCart, changedLineId, properties) {
    var oldItem = (previousCart && previousCart.items || []).find(function (item) { return item.key === changedLineId; });
    Array.prototype.forEach.call(document.querySelectorAll(CART_ITEM_SELECTOR), function (target) {
      var items = cart && cart.items || [];
      var item = items.find(function (entry) { return entry.key === target.dataset.key; });
      var quantityInput;
      var removeLink;

      if (!item && oldItem && target.dataset.key === changedLineId) {
        var candidates = items.filter(function (entry) {
          return String(entry.variant_id) === String(oldItem.variant_id) && entry.sku === oldItem.sku &&
            entry.quantity === oldItem.quantity && cartLinePropertiesMatch(entry.properties, properties);
        });
        if (candidates.length === 1) item = candidates[0];
      }
      if (!item || !item.key) return;

      var display = cartDeliveryDisplay.get(target.dataset.key);
      if (display && target.dataset.key !== item.key) {
        cartDeliveryDisplay.set(item.key, display);
      }
      target.dataset.key = item.key;
      target.dataset.line = String(items.indexOf(item) + 1);
      quantityInput = target.querySelector(".js-qty__num");
      if (quantityInput) quantityInput.dataset.id = item.key;

      removeLink = target.querySelector(".cart__remove a[data-item-key]");
      if (removeLink) {
        removeLink.dataset.itemKey = item.key;
        removeLink.href = getCartEndpoint("cart/change?id=" + encodeURIComponent(item.key) + "&quantity=0");
      }
    });
  }

  function cartPropertyMarker(cart, pincode) {
    return JSON.stringify(["serviceability2-v1", getRequestLocationKey(pincode), cartFingerprint(cart)]);
  }

  function readCartPropertyMarker() {
    try {
      var marker = JSON.parse(window.sessionStorage.getItem("libasCartDeliveryLineProperties") || "null");
      return marker && marker.expiresAt > Date.now() ? marker.value : "";
    } catch (error) {
      return "";
    }
  }

  function writeCartPropertyMarker(cart, pincode, expiresAt) {
    try {
      window.sessionStorage.setItem("libasCartDeliveryLineProperties", JSON.stringify({
        value: cartPropertyMarker(cart, pincode), expiresAt: expiresAt
      }));
    } catch (error) {
      // sessionStorage can be unavailable in embedded or private contexts.
    }
  }

  function syncCartLineProperties(results, pincode) {
    if (window.LibasCartUpdates) {
      return window.LibasCartUpdates.run(function () { return writeCartLineProperties(results, pincode); });
    }
    return writeCartLineProperties(results, pincode);
  }

  function writeCartLineProperties(results, pincode) {
    if (!window.__libasAsapConfig.enabled || !window.__libasAsapConfig.cartHandoffEnabled) return Promise.resolve(null);
    var cartResults = (results || []).filter(function (result) {
      return result && result.lineId && cartRequestIsCurrent(result.request);
    });

    if (!cartResults.length || sanitizePincode(pincode).length !== 6) return Promise.resolve(null);

    cartLinePropertyWrite = cartLinePropertyWrite.catch(function () {
      return null;
    }).then(function () {
      return fetchCartJson();
    }).then(function (cart) {
      if (cartResults.some(function (result) {
        return !cartRequestIsCurrent(result.request) || result.request.fingerprint !== cartFingerprint(cart);
      })) return null;
      return cartResults.reduce(function (chain, result) {
        return chain.then(function (expectedCart) {
          if (!expectedCart || !cartRequestIsCurrent(result.request) || !window.__libasAsapConfig.cartHandoffEnabled) return null;
          return fetchCartJson().then(function (currentCart) {
            if (!cartRequestIsCurrent(result.request) || cartFingerprint(currentCart) !== cartFingerprint(expectedCart)) return null;
            var item = currentCart.items.find(function (entry) { return entry.key === result.lineId; });
            if (!item) return null;
            var mergedProperties = mergeCartLineProperties(item.properties || {}, buildCartLineDeliveryProperties(result, pincode));
            if (cartLinePropertiesMatch(item.properties || {}, mergedProperties)) return currentCart;
            return window.fetch(getCartEndpoint("cart/change.js"), {
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: mergedProperties }),
              credentials: "same-origin",
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              method: "POST"
            }).then(function (response) {
              if (!response.ok) throw new Error("Cart line delivery properties could not be saved.");
              return response.json();
            }).then(function (updatedCart) {
              if (!cartPropertyWriteMatches(currentCart, updatedCart, item.key, mergedProperties)) {
                cartDeliveryRecoveryPending = true;
                invalidateCartDelivery();
                syncCartCheckoutBlocking();
                scheduleCartLinePropertyRefresh(true, 80);
                if (updatedCart && updatedCart.token === currentCart.token && Array.isArray(updatedCart.items) &&
                    updatedCart.items.every(function (entry) { return entry && typeof entry.key === "string"; })) {
                  syncCartTargetKeys(updatedCart, currentCart, item.key, mergedProperties);
                }
                return null;
              }
              syncCartTargetKeys(updatedCart, currentCart, item.key, mergedProperties);
              return updatedCart;
            });
          });
        });
      }, Promise.resolve(cart));
    }).then(function (cart) {
      if (cart && cartResults.every(function (result) { return cartRequestIsCurrent(result.request); })) {
        var containers = Array.prototype.slice.call(document.querySelectorAll(CART_PRODUCTS_SELECTOR));
        if (containers.some(function (container) { return !cartTargetsMatch(cart, container); })) {
          cartDeliveryRecoveryPending = true;
          invalidateCartDelivery();
          syncCartCheckoutBlocking();
          scheduleCartLinePropertyRefresh(true, 80);
          return null;
        }
        cartDeliveryRecoveryPending = false;
        syncCartCheckoutBlocking();
        if (cartResults.length === cart.items.length && cartResults.every(function (result) { return result.status !== "error"; })) {
          writeCartPropertyMarker(cart, pincode, Math.min.apply(Math, cartResults.map(function (result) { return result.request.expiresAt; })));
        }
        document.dispatchEvent(new CustomEvent("libas:cart-line-properties:updated", {
          detail: { cart: cart }
        }));
      }
      return cart;
    }).catch(function () {
      return null;
    });

    return cartLinePropertyWrite;
  }

  function fetchDetachedCartTargets() {
    return window.fetch(getCartEndpoint("cart?view=ajax"), {
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart delivery data could not be loaded.");
      return response.text();
    }).then(function (html) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = html;
      return wrapper;
    });
  }

  function cartTargetsMatch(cart, scope) {
    var targets = Array.prototype.slice.call(scope.querySelectorAll(CART_ITEM_SELECTOR));
    var items = cart && cart.items || [];
    return targets.every(function (target) {
      var item = items.find(function (entry) { return entry.key === target.dataset.key; });
      var input = target.querySelector(".js-qty__num");
      return item && String(item.variant_id) === target.dataset.libasDeliveryVariantId &&
        normalizeText(item.sku) === normalizeText(target.dataset.libasDeliverySku) && input &&
        Number(input.value) === item.quantity && input.dataset.id === item.key;
    }) && items.every(function (item) {
      return targets.some(function (target) { return target.dataset.key === item.key; });
    });
  }

  function refreshCartTargets(pincode) {
    var revision = cartDeliveryRevision;
    var locationKey = getRequestLocationKey(pincode);
    function refresh() {
      return fetchDetachedCartTargets().then(function (wrapper) {
        return fetchCartJson().then(function (cart) {
          if (!window.__libasAsapConfig.enabled || revision !== cartDeliveryRevision ||
              locationKey !== getRequestLocationKey(getSavedPincode())) return null;
          if (!wrapper.querySelector(".cart__items") || !cartTargetsMatch(cart, wrapper)) {
            throw new Error("Cart markup does not match the current cart.");
          }
          var containers = Array.prototype.slice.call(document.querySelectorAll(CART_PRODUCTS_SELECTOR));
          var forms = containers.map(function (container) {
            var form = container.closest("form");
            return form && form.__diCartFormInstance;
          });
          if (forms.some(function (form) { return !form || typeof form.cartMarkup !== "function"; })) {
            throw new Error("Cart renderer is not ready.");
          }
          forms.forEach(function (form) { form.cartMarkup(wrapper.innerHTML); });
          if (containers.some(function (container) { return !cartTargetsMatch(cart, container); })) {
            throw new Error("Visible cart could not be reconciled.");
          }
          observeCartContainers();
          syncCartCheckoutBlocking();
          return { cart: cart, context: containers.length ? document : wrapper };
        });
      });
    }
    return window.LibasCartUpdates ? window.LibasCartUpdates.run(refresh) : refresh();
  }

  function refreshDetachedCartLineProperties(force) {
    if (!window.__libasAsapConfig.enabled || !window.__libasAsapConfig.cartHandoffEnabled) return Promise.resolve(null);
    var pincode = getSavedPincode();

    if (pincode.length !== 6) return Promise.resolve(null);
    if (cartPropertyRefreshInFlight) {
      cartPropertyRefreshQueued = cartPropertyRefreshQueued || Boolean(force);
      return cartPropertyRefreshInFlight;
    }

    cartPropertyRefreshInFlight = fetchCartJson().then(function (cart) {
      if (!cart) return null;
      var containers = Array.prototype.slice.call(document.querySelectorAll(CART_PRODUCTS_SELECTOR));
      var hasCurrentTargets = cartTargetsMatch(cart, document) &&
        containers.every(function (container) { return cartTargetsMatch(cart, container); });
      if (!cartDeliveryRecoveryPending && hasCurrentTargets) {
        if (!cart.item_count || !force && readCartPropertyMarker() === cartPropertyMarker(cart, pincode)) return cart;
        return applyDeliveryPromises(document, getActiveLocationIds(), true);
      }
      if (containers.length) {
        cartDeliveryRecoveryPending = true;
        syncCartCheckoutBlocking();
      }
      return refreshCartTargets(pincode).then(function (refreshed) {
        if (!refreshed) return null;
        if (!refreshed.cart.item_count) {
          cartDeliveryRecoveryPending = false;
          syncCartCheckoutBlocking();
          return refreshed.cart;
        }
        return applyDeliveryPromises(refreshed.context, getActiveLocationIds(), true);
      });
    }).catch(function () {
      return null;
    }).finally(function () {
      var runAgain = cartPropertyRefreshQueued;
      cartPropertyRefreshQueued = false;
      cartPropertyRefreshInFlight = null;
      if (runAgain) scheduleCartLinePropertyRefresh(true, 80);
    });

    return cartPropertyRefreshInFlight;
  }

  function scheduleCartLinePropertyRefresh(force, delay) {
    window.clearTimeout(cartPropertyRefreshTimer);
    cartPropertyRefreshTimer = window.setTimeout(function () {
      return refreshDetachedCartLineProperties(Boolean(force));
    }, delay == null ? 500 : delay);
  }

  window.LibasCartDeliveryHandoff = {
    flush: function () {
      window.clearTimeout(cartPropertyRefreshTimer);
      return refreshDetachedCartLineProperties(false);
    }
  };

  function getProductCardDataTargets(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll(CARD_SELECTOR));

    if (scope.matches && scope.matches(CARD_SELECTOR)) {
      cards.unshift(scope);
    }

    return cards.filter(function (card, index, list) {
      return list.indexOf(card) === index;
    });
  }

  function needsProductCardData(card) {
    if (!isProductCard(card)) return false;
    if (card.dataset.libasHldHydrated === "true") return false;
    if (card.dataset.libasHldHydrationFailed === "true") return false;
    if (!normalizeText(card.dataset.productHandle)) return false;
    return true;
  }

  function parseProductCardData(html) {
    var wrapper = document.createElement("div");
    var dataNode;

    wrapper.innerHTML = html;
    dataNode = wrapper.querySelector("[data-libas-product-card-hld-data]");
    if (!dataNode) return null;

	    return {
	      available: dataNode.getAttribute("data-libas-delivery-available") || "",
	      inventoryTypes: dataNode.getAttribute("data-libas-inventory-types") || "",
	      locationIds: dataNode.getAttribute("data-libas-hld-location-ids") || "",
	      sku: dataNode.getAttribute("data-libas-delivery-sku") || "",
	      variantId: dataNode.getAttribute("data-libas-delivery-variant-id") || ""
    };
  }

  function fetchProductCardData(handle) {
    var normalizedHandle = normalizeText(handle);
    var url;

    if (!normalizedHandle) return Promise.resolve(null);
    if (productCardDataCache[normalizedHandle]) return productCardDataCache[normalizedHandle];

    url = "/products/" + encodeURIComponent(normalizedHandle) + "?section_id=" + encodeURIComponent(PRODUCT_CARD_HLD_SECTION);

    productCardDataCache[normalizedHandle] = window.fetch(url, {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Product delivery data unavailable.");
      return response.text();
    }).then(parseProductCardData).catch(function () {
      return null;
    });

    return productCardDataCache[normalizedHandle];
  }

  function hydrateProductCardData(context) {
    getProductCardDataTargets(context).forEach(function (card) {
      var handle;

      if (!needsProductCardData(card)) return;

      handle = normalizeText(card.dataset.productHandle);
      card.dataset.libasHldHydrationPending = "true";

      fetchProductCardData(handle).then(function (data) {
        delete card.dataset.libasHldHydrationPending;

        if (!data) {
          card.dataset.libasHldHydrationFailed = "true";
          return;
        }

	        card.dataset.libasHldLocationIds = data.locationIds || "";
	        card.dataset.libasInventoryTypes = data.inventoryTypes || "";
	        card.dataset.libasDeliverySku = data.sku || "";
        card.dataset.libasDeliveryVariantId = data.variantId || "";
        card.dataset.libasDeliveryAvailable = data.available || "true";
        card.dataset.libasHldHydrated = "true";
        schedule(card, 0);
      });
    });
  }

  function applyDeliveryPromises(context, activeLocationIds, syncLineProperties) {
    if (!window.__libasAsapConfig.enabled) return Promise.resolve([]);
    var pincode = getSavedPincode();
    var locationKey = getRequestLocationKey(pincode);
    var cartTargets = [];
    var activeIds = normalizeIdList(activeLocationIds || getActiveLocationIds());

    getDeliveryTargets(context).forEach(function (target) {
      var isCartItem = target.matches && target.matches(CART_ITEM_SELECTOR);

      if (isCartItem) {
        if (pincode.length === 6) cartTargets.push(target);
        else {
          removeStamp(target);
          removeCartLoader(target);
          removeCartInventoryWarning(target);
        }
        return;
      }

      if (isProductCard(target) && !syncNormalInventoryVisibility(target, activeIds)) {
        return;
      }

      if (!isDeliveryTargetAvailable(target)) {
        removeStamp(target);
        return;
      }

      if (shouldShowProductLevelHld(target, activeIds)) {
        addStamp(target, { isHld: true, promiseText: "Get it in 2 hours" });
        return;
      }

      if (isProductCard(target) && target.dataset.libasHldHydrationPending === "true") {
        removeStamp(target);
        return;
      }

      if (isProductCard(target)) {
        addStamp(target, { isHld: false, promiseText: EXPRESS_PROMISE_TEXT });
        return;
      }

    });

    if (!cartTargets.length) {
      syncCartCheckoutBlocking();
      return Promise.resolve([]);
    }

    restoreCartDeliveryDisplay(context);

    return fetchCartDeliveryPromises(cartTargets, pincode).then(function (results) {
      if (getSavedPincode() !== pincode || getRequestLocationKey(pincode) !== locationKey) return [];

      results.forEach(function (result) {
        if (!cartRequestIsCurrent(result.request)) return;
        cartDeliveryDisplay.set(result.lineId, {
          displayKey: result.request.displayKey,
          inventoryKey: cartTargetInventoryKey(result.target),
          expiresAt: result.request.expiresAt,
          result: { status: result.status, promise: result.promise, displayPromise: result.displayPromise }
        });
      });
      while (cartDeliveryDisplay.size > 100) cartDeliveryDisplay.delete(cartDeliveryDisplay.keys().next().value);
      restoreCartDeliveryDisplay(document);
      syncCartCheckoutBlocking();
      return syncLineProperties ? syncCartLineProperties(results, pincode) : results;
    });
  }

  function applyCartStamps(context, ids) {
    return;
  }

  function runForRoot(root) {
    removeStamps(root, false);
  }

  function run(context) {
    var ids = getActiveLocationIds();

    injectStyles();
    hydrateProductCardData(context || document);

    getRoots(context).forEach(function (root) {
      runForRoot(root);
    });

    applyCartStamps(context || document, ids);
    applyDeliveryPromises(context || document, ids, false);
  }

  var pendingRunContext = null;
  function schedule(context, delay) {
    var requestedContext = context || document;
    pendingRunContext = pendingRunContext && pendingRunContext !== requestedContext ? document : requestedContext;
    window.clearTimeout(runTimer);
    runTimer = window.setTimeout(function () {
      var scheduledContext = pendingRunContext || document;
      pendingRunContext = null;
      if (window.requestIdleCallback) {
        window.requestIdleCallback(function () {
          run(scheduledContext);
        }, { timeout: 2200 });
      } else {
        run(scheduledContext);
      }
    }, delay == null ? 120 : delay);
  }

  function clearCacheAndSchedule(context, clearDisplay) {
    fetchCache = {};
    invalidateCartDelivery(clearDisplay);
    schedule(context || document, 60);
  }

  function invalidateCartDelivery(clearDisplay) {
    cartDeliveryRevision += 1;
    cartDeliveryCache.clear();
    try { window.sessionStorage.removeItem("libasCartDeliveryLineProperties"); } catch (error) {}
    if (clearDisplay !== false) cartDeliveryDisplay.clear();
    restoreCartDeliveryDisplay(document);
  }

  function observeCartContainers() {
    var container = document.querySelector("#CartDrawer [data-products]") || document.querySelector("[data-products].cart__page-col");

    if (!container || cartObserver && cartObserver.target === container) return;

    if (cartObserver && cartObserver.observer) {
      cartObserver.observer.disconnect();
    }

    cartObserver = {
      observer: new MutationObserver(function (mutations) {
        var cartStructureChanged = mutations.some(function (mutation) {
          var changedNodes = Array.prototype.slice.call(mutation.addedNodes || [])
            .concat(Array.prototype.slice.call(mutation.removedNodes || []));

          if (mutation.target === container) return true;

          return changedNodes.some(function (node) {
            if (!node || node.nodeType !== 1) return false;
            return Boolean(
              node.matches && node.matches(CART_ITEM_SELECTOR) ||
              node.querySelector && node.querySelector(CART_ITEM_SELECTOR)
            );
          });
        });

        if (cartStructureChanged) {
          restoreCartDeliveryDisplay(container);
          schedule(container, 60);
        }
      }),
      target: container
    };
    cartObserver.observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  function nodeContainsProductCard(node) {
    if (!node || node.nodeType !== 1) return false;
    return Boolean(
      node.matches && node.matches(CARD_SELECTOR) ||
      node.querySelector && node.querySelector(CARD_SELECTOR)
    );
  }

  function observeCollectionContainers() {
    var containers = [];
    [
      ROOT_SELECTOR,
      "#CollectionAjaxContent",
      '[data-section-type="collection-grid"]',
      '[data-section-type="product-recommendations"]',
      '[data-section-type="recently-viewed"]'
    ].forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (container) {
        if (containers.indexOf(container) === -1) {
          containers.push(container);
        }
      });
    });

    containers.forEach(function (container) {
      var exists = collectionObservers.some(function (entry) {
        return entry.target === container;
      });
      var observer;

      if (exists) return;

      observer = new MutationObserver(function (mutations) {
        var hasProductCards = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes || [], nodeContainsProductCard);
        });

        if (hasProductCards) {
          schedule(container, 80);
        }
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });

      collectionObservers.push({
        observer: observer,
        target: container
      });
    });
  }

  function boot() {
    schedule(document, 300);
    scheduleCartLinePropertyRefresh(false, 900);
    observeCartContainers();
    observeCollectionContainers();

    document.addEventListener("collection:infinite-loaded", function (event) {
      observeCollectionContainers();
      schedule(event.detail && event.detail.root ? event.detail.root : document, 60);
    });

    document.addEventListener("recommendations:loaded", function (event) {
      observeCollectionContainers();
      schedule(event.detail && event.detail.section ? event.detail.section : document, 60);
    });

    document.addEventListener("collection:reloaded", function () {
      observeCollectionContainers();
      clearCacheAndSchedule(document, false);
    });

    window.addEventListener("libas:delivery-location:selected", function () {
      observeCollectionContainers();
      clearCacheAndSchedule(document);
      scheduleCartLinePropertyRefresh(true, 160);
    });

    window.addEventListener("libas:delivery-serviceability:checking", function () {
      fetchCache = {};
      invalidateCartDelivery(true);
      removeStamps(document, true);
    });

    document.addEventListener("cart:updated", function () {
      invalidateCartDelivery(false);
      observeCartContainers();
      schedule(document, 80);
      scheduleCartLinePropertyRefresh(true, 220);
    });

    document.addEventListener("ajaxProduct:added", function () {
      invalidateCartDelivery(false);
      observeCartContainers();
      schedule(document, 180);
      scheduleCartLinePropertyRefresh(true, 320);
    });

    document.addEventListener("click", function (event) {
      var checkoutAction = event.target && event.target.closest && event.target.closest("#CartDrawer .gokwik-checkout a, #CartDrawer [name='checkout']");
      if (!checkoutAction || !document.body.classList.contains("libas-cart-has-inventory-block")) return;
      event.preventDefault();
      event.stopPropagation();
      syncCartCheckoutBlocking();
    }, true);

    document.addEventListener("page:loaded", function () {
      observeCartContainers();
      observeCollectionContainers();
      schedule(document, 120);
      scheduleCartLinePropertyRefresh(false, 700);
    });

    window.addEventListener("pageshow", function () {
      observeCartContainers();
      observeCollectionContainers();
      schedule(document, 120);
      scheduleCartLinePropertyRefresh(false, 700);
    });
  }

  if (document.readyState === "complete") {
    boot();
  } else {
    window.addEventListener("load", boot, { once: true });
  }
})();
